import axios, { AxiosHeaders } from 'axios';
import { API_BASE_URL } from '@/config/app';
import { publicToken, savePublicToken } from '@/support/publicSession';

let unauthorizedHandler: (() => void) | undefined;
export function onPublicUnauthorized(handler: () => void): void { unauthorizedHandler = handler; }

// Instance isolée : ni les intercepteurs staff, ni leur jeton, ni X-Shop-Id.
const publicApi = axios.create({ baseURL: API_BASE_URL, withCredentials: false, headers: { Accept: 'application/json' } });
publicApi.interceptors.request.use((config) => {
  if (!config.url?.startsWith('/public/') || config.url.includes('\\')) {
    throw new Error('Cette requête ne fait pas partie de l’espace client.');
  }
  config.headers = AxiosHeaders.from(config.headers);
  config.headers.delete('Authorization');
  config.headers.delete('X-Shop-Id');
  const token = publicToken();
  if (token && /^\/public\/(orders|auth\/(me|logout|verification-notification|verify-email))$/.test(config.url)) {
    config.headers.set('Authorization', `Bearer ${token}`);
  }
  return config;
});
publicApi.interceptors.response.use((response) => response, (error) => {
  const sentToken = AxiosHeaders.from(error.config?.headers).get('Authorization');
  // Une réponse tardive de l'ancien compte ne doit pas déconnecter le nouveau.
  if (error.response?.status === 401 && sentToken && sentToken === `Bearer ${publicToken()}`) {
    savePublicToken('');
    unauthorizedHandler?.();
  }
  return Promise.reject(error);
});
export default publicApi;
